const getFinalPrice = ({ subTotal, taxTotal, currencyCode, total }) => {
  // Validar que currencyCode sea un string válido
  const validCurrencyCode = currencyCode && typeof currencyCode === 'string' ? currencyCode : 'USD';

  // Función auxiliar para validar y convertir números (maneja strings y números)
  const safeParseFloat = (value) => {
    if (value === null || value === undefined || value === '') return 0;

    // Si ya es un número, validarlo
    if (typeof value === 'number') {
      return isNaN(value) ? 0 : value;
    }

    // Si es string, intentar convertirlo
    if (typeof value === 'string') {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parsed;
    }

    // Para cualquier otro tipo, intentar convertirlo
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  // Calcular el precio total con validaciones
  let price;
  if (total !== null && total !== undefined && total !== '') {
    price = safeParseFloat(total);
  } else {
    const subTotalValue = safeParseFloat(subTotal);
    const taxTotalValue = safeParseFloat(taxTotal);
    price = subTotalValue + taxTotalValue;
  }

  // Asegurar que el precio sea un número válido
  if (isNaN(price) || price < 0) {
    price = 0;
  }

  // Formatear el precio
  return `${validCurrencyCode} ${price.toLocaleString('es-AR')}`;
};

export default getFinalPrice;
